// url-history.service.ts
import { inject, Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouterHistoryService {
  private urls: string[] = [];

  router = inject(Router);
  constructor() {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (event.urlAfterRedirects !== '/') {
        this.urls.push(event.urlAfterRedirects);
      }
    });
  }

  getPreviousUrl(): string | null {
    return this.urls.length > 1 ? this.urls[this.urls.length - 2] : null;
  }
}